import { DrawStage } from "@toorak/tc-common-fe-sdk";
import { drawsActionBtnInterface } from "../../stores/drawRequest/drawRequest.interface";
import { isOnlyDrawMember } from "../AssetManagement.utils";

const {
  drawSubmitted,
  initialApproval,
  finalApproval,
  inProgress,
  decline,
  hold,
  wireTransferInitiated,
  wireCompleted,
  WireUnsuccessful,
  DrawInQueue,
  originatorPending,
  wireStatusReview
} = DrawStage;
export const drawsStageUpdate: drawsActionBtnInterface[] = [
  {
    title: drawSubmitted,
    allowedStatus: [DrawInQueue]
  },
  {
    title: inProgress,
    allowedStatus: [
      drawSubmitted,
      decline,
      hold,
      DrawInQueue,
      WireUnsuccessful,
      wireTransferInitiated,
      wireStatusReview
    ]
  },
  {
    title: hold,
    allowedStatus: [
      drawSubmitted,
      initialApproval,
      finalApproval,
      decline,
      inProgress,
      originatorPending,
      WireUnsuccessful,
      DrawInQueue,
      wireTransferInitiated,
      wireStatusReview
    ]
  },
  {
    title: decline,
    allowedStatus: [
      drawSubmitted,
      initialApproval,
      finalApproval,
      wireTransferInitiated,
      hold,
      inProgress,
      WireUnsuccessful,
      originatorPending,
      DrawInQueue,
      wireStatusReview
    ]
  },
  {
    title: wireStatusReview,
    allowedStatus: [wireTransferInitiated, wireCompleted]
  },

  {
    title: initialApproval,
    allowedStatus: [inProgress, originatorPending]
  },
  {
    title: finalApproval,
    allowedStatus: [initialApproval]
  },
  {
    title: wireTransferInitiated,
    allowedStatus: [
      // drawSubmitted,
      finalApproval,
      WireUnsuccessful,
      wireStatusReview
    ]
  },
  {
    title: WireUnsuccessful,
    allowedStatus: [wireTransferInitiated, wireStatusReview, wireCompleted]
  }
];

export const isBulkDrawViewEnabled = () =>
  sessionStorage.getItem("bulkDrawView") === "true";

export const progressList = [
  "Servicer Ready",
  "First Approval Ready",
  "Second Approval Ready",
  "Originator Pending",
  "Wire Sent",
  "Wire Ready",
  "Wire Verification Ready"
];

export const isStatusDisabled = (
  item: drawsActionBtnInterface,
  stage: DrawStage,
  finalApprovalNotRequired: string
): boolean => {
  const isAllowed = (): boolean => !item.allowedStatus.includes(stage);

  const statusesThatRequireAllowedCheck = [
    inProgress,
    hold,
    decline,
    initialApproval,
    WireUnsuccessful,
    DrawInQueue,
    drawSubmitted,
    wireStatusReview,
    wireCompleted
    // originator Pending
  ];

  const isFinalApprovalNotRequired =
    finalApprovalNotRequired?.toLowerCase() === "yes";

  if (statusesThatRequireAllowedCheck.includes(item.title as DrawStage)) {
    return isAllowed();
  }
  if (item.title === wireTransferInitiated) {
    return isFinalApprovalNotRequired && stage === initialApproval
      ? false
      : isAllowed();
  }
  if (item.title === finalApproval) {
    if (!isFinalApprovalNotRequired && !isOnlyDrawMember()) {
      return isAllowed();
    }
    return true;
  }
  return true;
};
